const HUES = {
  blue: "from-[#0a1430] via-[#070a16] to-[#030305]",
  violet: "from-[#191029] via-[#0b0812] to-[#030305]",
  gold: "from-[#221a09] via-[#100c06] to-[#030305]",
  red: "from-[#1d0708] via-[#0e0506] to-[#030305]",
  veil: "from-[#0c0c14] via-[#07070c] to-[#030305]",
};

const GLOWS = {
  blue: "rgba(42,82,190,0.28)",
  violet: "rgba(106,76,147,0.28)",
  gold: "rgba(212,175,55,0.18)",
  red: "rgba(139,0,0,0.32)",
  veil: "rgba(245,245,250,0.05)",
};

const ArtFrame = ({ image, label, hue = "blue", ratio = "aspect-[2/3]", className = "", veil = false, children }) => {
  if (image) {
    return (
      <div className={`relative overflow-hidden ${ratio} ${className}`}>
        <img
          src={image}
          alt={label || "Cosmic Dreams artwork"}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
        />
        {children}
      </div>
    );
  }

  return (
    <div
      className={`relative overflow-hidden bg-gradient-to-b ${HUES[hue] || HUES.blue} ${veil ? "veil-shimmer" : ""} ${ratio} ${className}`}
      data-art-slot={label}
    >
      <div
        className="absolute inset-0"
        style={{ background: `radial-gradient(ellipse 80% 55% at 50% 68%, ${GLOWS[hue] || GLOWS.blue}, transparent 70%)` }}
      />
      <div className="absolute left-[18%] top-[22%] h-px w-px rounded-full bg-white/70 shadow-[0_0_6px_1px_rgba(255,255,255,0.7)]" />
      <div className="absolute right-[26%] top-[38%] h-0.5 w-0.5 rounded-full bg-[#cdd7f5]/60" />
      <div className="absolute left-[34%] top-[58%] h-px w-px rounded-full bg-[#D4AF37]/70" />
      <div className="absolute right-[18%] bottom-[24%] h-px w-px rounded-full bg-white/40" />
      <span className="absolute left-2 top-2 h-4 w-4 border-l border-t border-white/25" />
      <span className="absolute right-2 top-2 h-4 w-4 border-r border-t border-white/25" />
      <span className="absolute bottom-2 left-2 h-4 w-4 border-b border-l border-white/25" />
      <span className="absolute bottom-2 right-2 h-4 w-4 border-b border-r border-white/25" />
      {label && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 px-4 text-center">
          <span className="font-serif text-xl text-white/25">✦</span>
          <span className="font-mono text-[10px] tracking-[0.3em] text-white/40 uppercase">{label}</span>
          <span className="font-mono text-[8px] tracking-[0.25em] text-white/20 uppercase">Artwork pending</span>
        </div>
      )}
      {children}
    </div>
  );
};

export default ArtFrame;
